import { defineComponent as _defineComponent } from 'vue'
import { ReadyType } from '@/stores/ready.store';

import { useRoutingStore, useUserStore } from '@/helpers/composables/useStores';
import Vue, { computed, onMounted } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'StaticPage',
  setup(__props) {

const routingStore = useRoutingStore();
const userStore = useUserStore();

onMounted(async () => {
	await routingStore.urlMetadataPromise.value;
	await Vue.$jw.ready?.waitFor(ReadyType.JW_ID);

	if (routingStore.urlMetadata.value?.htmlContentJson?.script) {
		// there is some JS written up in the static page targetting elements that no longer exist (old design?)
		// ie: https://intranet.justwatch.com/dashboards/panel/cms/pages/42/en_US
		// It's in every country/locale and changing it is a whole thing so for now I ignore the error
		try {
			new Function(routingStore.urlMetadata.value.htmlContentJson.script)?.();
		} catch {}
	}
});

const htmlContent = computed(() => {
	const htmlContent = routingStore.urlMetadata.value?.htmlContentJson;
	return (htmlContent?.default || htmlContent?.compile || '').replace(
		new RegExp('{{BEST_EFFORT_ID}}', 'g'),
		userStore.bestEffortId.value
	);
});

const pageType = computed(() => {
	if (routingStore.urlMetadata.value?.metaTitle === 'TV Code') {
		return 'tvcode';
	}

	return routingStore.urlMetadata.value?.htmlContentJson?.landing_page_type || 'static';
});

return { __sfc: true,routingStore, userStore, htmlContent, pageType }
}

})